import { render } from "./SelectMulti.vue?vue&type=template&id=15f4e1f6&scoped=true"
import script from "./SelectMulti.vue?vue&type=script&lang=js"
export * from "./SelectMulti.vue?vue&type=script&lang=js"

import "./SelectMulti.vue?vue&type=style&index=0&id=15f4e1f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f4e1f6"]])

export default __exports__